import { render } from "./AlertModal.vue?vue&type=template&id=200a87e1&ts=true"
import script from "./AlertModal.vue?vue&type=script&lang=ts"
export * from "./AlertModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Widgets/AlertModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "200a87e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('200a87e1', __exports__)) {
    api.reload('200a87e1', __exports__)
  }
  
  module.hot.accept("./AlertModal.vue?vue&type=template&id=200a87e1&ts=true", () => {
    api.rerender('200a87e1', render)
  })

}


export default __exports__